import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { config } from '../config';
import { prepareHeaders } from '../configuration/tokenHandling/prepareHeaders';
import type { UntranslatedServiceItem } from '../data/serviceData';
import { type AppResponse, mapToServiceList } from './appsMapper';

export const appsApi = createApi({
    reducerPath: 'appsApi',
    baseQuery: fetchBaseQuery({ baseUrl: config.backend.APPS_URL, prepareHeaders }),
    endpoints: builder => ({
        fetchApps: builder.query<UntranslatedServiceItem[], string | undefined>({
            query: locale => `?locale=${locale}`,
            transformResponse: (response: AppResponse) => mapToServiceList(response),
            keepUnusedDataFor: 100,
        }),
    }),
});

// Export hooks for usage in function components which are
// auto-generated based on defined endpoints
export const { useFetchAppsQuery } = appsApi;
